var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app auth-page",style:(_vm.authStyle),attrs:{"id":"auth"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.loading)?_c('div',{staticClass:"loader-container"},[_c('loader')],1):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }